import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors, fontSize } from '../../constants/styleConstants';

const Title = styled.span`
  font-size: ${props => {
    switch (props.size) {
      case 'small':
        return fontSize.smallTitle;
      case 'big':
        return fontSize.basic;
      case 'medium':
        return fontSize.medium;
      default:
        return fontSize.regularTitle;
    }
  }}px;
  color: ${props => {
    switch (props.color || props.size) {
      case 'light':
      case 'small':
        return colors.cardTitle;
      case 'lightTitle':
        return colors.lightTitle;
      case 'big':
        return colors.grey3;
      case 'medium':
        return colors.grey3;
      default:
        return colors.subTitle;
    }
  }};
  font-weight: ${props => {
    switch (props.weight || props.size) {
      case 'regular':
        return 'bold';
      case 'normal':
        return 'normal';
      default:
        return 'normal';
    }
  }};
  line-height: ${props => 
    props.lineHeight && props.lineHeight
}};
`;

Title.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'regular', 'big', 'normal']),
  color: PropTypes.oneOf(['light', 'lightTitle', 'default']),
};

Title.defaultProps = {
  size: 'regular',
};

export default Title;
